class StoreLocator extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.item');
    this.map = this.querySelector('#map');
    this.stateFilter = document.getElementById('stateFilter');
    this.citySearch = document.getElementById('citySearch');

    // Store click event for switching map
    this.items.forEach(item => {
      item.addEventListener('click', this.onButtonClick.bind(this));
    });

    // Filter events
    if (this.stateFilter) {
      this.stateFilter.addEventListener('change', this.filterStores.bind(this));
    }

    if (this.citySearch) {
      this.citySearch.addEventListener('input', this.filterStores.bind(this));
    }
  }

  onButtonClick(event) {
    const target = event.currentTarget;
    const map = target.dataset.map;

    this.map.classList.add('map-loading');
    this.querySelector('.active')?.classList.remove('active');
    target.classList.add('active');

    setTimeout(() => {
      this.map.innerHTML = map;
    }, 300);

    setTimeout(() => {
      this.map.classList.remove('map-loading');
    }, 1200);
  }

  filterStores() {
    const state = this.stateFilter?.value.toLowerCase() || '';
    const city = this.citySearch?.value.toLowerCase() || '';

    this.items.forEach(item => {
      const itemState = item.dataset.state?.toLowerCase() || '';
      const itemCity = item.dataset.city?.toLowerCase() || '';

      const matchState = !state || itemState === state;
      const matchCity = !city || itemCity.includes(city);

      item.style.display = (matchState && matchCity) ? '' : 'none';
    });
  }
}

customElements.define('store-locator', StoreLocator);
